import Auth from '../api/auth';

const parseErrorCode = error => {
  // Conta suspensa (trial vencido/inadimplente): manda pro paywall. O guard de
  // navegacao so cobre trocas de rota; isto cobre a suspensao no meio da sessao.
  if (
    error?.response?.status === 401 &&
    error?.response?.data?.error === 'Account is suspended'
  ) {
    const [, accountId] =
      window.location.pathname.match(/accounts\/(\d+)/) || [];
    const alreadyThere =
      window.location.pathname.includes('/suspended') ||
      window.location.pathname.includes('/settings/subscription');
    if (accountId && !alreadyThere) {
      window.location.assign(`/app/accounts/${accountId}/suspended`);
    }
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
